import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e8fa6732"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ss-lateral-contratacao" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("img", {
        src: "/static/img/ss-logo.png",
        alt: "NeoX by Sabre Sistemas"
      }),
      /*#__PURE__*/_createElementVNode("h2", null, "Você está a poucos passos de uma nova experiência...")
    ])
  ])
], -1))
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_4 = {
  key: 0,
  class: "ss-dados-contratacao ss-dados-contratacao-space"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "ss-dados-contratacao" }
const _hoisted_7 = {
  key: 0,
  class: "ss-dados-contratacao-space"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Vamos começar?", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Precisamos de algumas informações para te conhecer melhor.", -1))
const _hoisted_10 = { class: "ss-dados-contratacao-form" }
const _hoisted_11 = { class: "ss-dados-contratacao-form-campos" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Nome", -1))
const _hoisted_13 = { class: "ss-dados-contratacao-form-campos" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "E-mail", -1))
const _hoisted_15 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_16 = { class: "ant-input-group-addon" }
const _hoisted_17 = { class: "ss-dados-contratacao-form-campos" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Telefone", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://sabresistemas.com.br/fale-com-consultor/",
  class: "ant-btn ant-btn-primary ss-tamanho-completo",
  type: "button"
}, "Entre em contato conosco", -1))
const _hoisted_20 = {
  key: 1,
  class: "ss-dados-contratacao-space"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Como você deseja utilizar o NeoX ?", -1))
const _hoisted_22 = { class: "ss-dados-contratacao-form" }
const _hoisted_23 = {
  key: 2,
  class: "ss-dados-contratacao-space"
}
const _hoisted_24 = { class: "ss-dados-contratacao-form" }
const _hoisted_25 = { class: "ss-dados-contratacao-form-campos" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://sabresistemas.com.br/fale-com-consultor/",
  class: "ant-btn ant-btn-primary ss-tamanho-completo",
  type: "button"
}, "Entre em contato conosco", -1))
const _hoisted_27 = {
  key: 3,
  class: "ss-dados-contratacao-space"
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Aguarde, por favor...", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Estamos verificando as suas informações.", -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Escolha um plano", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Conforme a sua necessidade", -1))
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = { class: "ss-dados-contratacao-planos" }
const _hoisted_37 = { class: "ss-dados-contratacao-titulo-plano" }
const _hoisted_38 = {
  key: 0,
  class: "ss-dados-contratacao-detalhes-preco"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-dados-contratacao-preco-plano" }, "Consulte", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-dados-contratacao-recorrencia-plano" }, null, -1))
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = {
  key: 1,
  class: "ss-dados-contratacao-detalhes-preco"
}
const _hoisted_43 = { class: "ss-dados-contratacao-preco-plano" }
const _hoisted_44 = { class: "ss-dados-contratacao-recorrencia-plano" }
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = { class: "ss-dados-contratacao-detalhes-plano" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = {
  key: 4,
  class: "ss-dados-contratacao-space"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Confirme todos seus dados antes de prosseguirmos.", -1))
const _hoisted_51 = { class: "ss-dados-contratacao-form" }
const _hoisted_52 = { class: "ss-dados-contratacao-form" }
const _hoisted_53 = { class: "ss-dados-contratacao-form-campos" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Tipo de Plano", -1))
const _hoisted_55 = ["value"]
const _hoisted_56 = { class: "ss-dados-contratacao-form-campos" }
const _hoisted_57 = { class: "ss-dados-contratacao-form-campos" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "E-mail", -1))
const _hoisted_59 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_60 = { class: "ant-input-group-addon" }
const _hoisted_61 = { class: "ss-dados-contratacao-form-campos" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Telefone", -1))
const _hoisted_63 = {
  key: 5,
  class: "ss-dados-contratacao-space"
}
const _hoisted_64 = {
  key: 6,
  class: "ss-dados-contratacao-space"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_page_header = _resolveComponent("a-page-header")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_icone = _resolveComponent("icone")!
  const _component_campo_telefone = _resolveComponent("campo-telefone")!
  const _component_campo_cpf = _resolveComponent("campo-cpf")!
  const _component_campo_cnpj = _resolveComponent("campo-cnpj")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_result = _resolveComponent("a-result")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        ((_ctx.state.planosAssinaturas.length === 0))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhum plano disponível no momento." })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              ((_ctx.state.passoAtivo > 1 && _ctx.state.passoAtivo <= 5))
                ? (_openBlock(), _createBlock(_component_a_page_header, {
                    key: 0,
                    title: " ",
                    onBack: _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.passoAtivo -= 1)))
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                ((_ctx.state.passoAtivo === 1))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _hoisted_8,
                      _hoisted_9,
                      _createElementVNode("div", _hoisted_10, [
                        (_ctx.state.mensagemValidacaoNome)
                          ? (_openBlock(), _createBlock(_component_a_alert, {
                              key: 0,
                              message: _ctx.state.mensagemValidacaoNome,
                              banner: ""
                            }, null, 8, ["message"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.novaContratacao.nome) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.novaContratacao.nome]
                          ])
                        ]),
                        (_ctx.state.mensagemValidacaoEmail)
                          ? (_openBlock(), _createBlock(_component_a_alert, {
                              key: 1,
                              message: _ctx.state.mensagemValidacaoEmail,
                              banner: ""
                            }, null, 8, ["message"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createElementVNode("span", _hoisted_15, [
                            _createElementVNode("span", _hoisted_16, [
                              _createVNode(_component_icone, {
                                class: "ss-icone",
                                nome: "email"
                              })
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.novaContratacao.email) = $event)),
                              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.limparContratanteEncontrado && _ctx.limparContratanteEncontrado(...args)))
                            }, null, 544), [
                              [_vModelText, _ctx.state.novaContratacao.email]
                            ])
                          ])
                        ]),
                        (_ctx.state.mensagemValidacaoTelefone)
                          ? (_openBlock(), _createBlock(_component_a_alert, {
                              key: 2,
                              message: _ctx.state.mensagemValidacaoTelefone,
                              banner: ""
                            }, null, 8, ["message"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createVNode(_component_campo_telefone, {
                            valor: _ctx.state.novaContratacao.telefone,
                            "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.novaContratacao.telefone) = $event))
                          }, null, 8, ["valor"])
                        ]),
                        (_ctx.state.contratanteEncontrado === 0)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 3,
                              class: "ant-btn ant-btn-primary ss-tamanho-completo ss-dados-contratacao-btn",
                              type: "button",
                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.iniciarProcesso && _ctx.iniciarProcesso(...args)))
                            }, "Continuar"))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                              _createElementVNode("button", {
                                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.redefinirSenha && _ctx.redefinirSenha(...args))),
                                class: "ant-btn ant-btn-primary ss-tamanho-completo ss-dados-contratacao-btn",
                                type: "button"
                              }, "Recuperar Senha"),
                              _hoisted_19
                            ], 64))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ((_ctx.state.passoAtivo === 2))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("h2", null, "Olá, " + _toDisplayString(_ctx.state.novaContratacao.nome), 1),
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("button", {
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.definirTipoUso(_ctx.ETipoUso.Pessoal))),
                          class: "ant-btn ant-btn-primary ss-tamanho-completo ss-dados-contratacao-btn",
                          type: "button"
                        }, [
                          _createVNode(_component_icone, {
                            class: "ss-icone-botao",
                            nome: "usuario"
                          }),
                          _createTextVNode("Controle Pessoal")
                        ]),
                        _createElementVNode("button", {
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.definirTipoUso(_ctx.ETipoUso.Empresarial))),
                          class: "ant-btn ant-btn-primary ss-tamanho-completo ss-dados-contratacao-btn",
                          type: "button"
                        }, [
                          _createVNode(_component_icone, {
                            class: "ss-icone-botao",
                            nome: "empresa"
                          }),
                          _createTextVNode("Gerenciar Empresa/Negócio")
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ((_ctx.state.passoAtivo === 3))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("h2", null, _toDisplayString(_ctx.state.novaContratacao.nome) + ",", 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.state.tipoUso === _ctx.ETipoUso.Pessoal ? 'Por favor, digite o seu CPF:' : 'Por favor, digite o seu CNPJ:'), 1),
                      _createElementVNode("div", _hoisted_24, [
                        (_ctx.state.mensagemValidacaoCpfCnpj)
                          ? (_openBlock(), _createBlock(_component_a_alert, {
                              key: 0,
                              message: _ctx.state.mensagemValidacaoCpfCnpj,
                              banner: ""
                            }, null, 8, ["message"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_25, [
                          (_ctx.state.tipoUso === _ctx.ETipoUso.Pessoal)
                            ? (_openBlock(), _createBlock(_component_campo_cpf, {
                                key: 0,
                                valor: _ctx.state.novaContratacao.cpfCnpj,
                                "onUpdate:valor": [
                                  _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.novaContratacao.cpfCnpj) = $event)),
                                  _ctx.limparContratanteEncontrado
                                ]
                              }, null, 8, ["valor", "onUpdate:valor"]))
                            : (_openBlock(), _createBlock(_component_campo_cnpj, {
                                key: 1,
                                valor: _ctx.state.novaContratacao.cpfCnpj,
                                "onUpdate:valor": [
                                  _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.novaContratacao.cpfCnpj) = $event)),
                                  _ctx.limparContratanteEncontrado
                                ]
                              }, null, 8, ["valor", "onUpdate:valor"]))
                        ]),
                        (_ctx.state.contratanteEncontrado === 0)
                          ? (_openBlock(), _createBlock(_component_a_spin, {
                              key: 1,
                              spinning: _ctx.state.aguardandoServidor
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.verificaCpfCnpj())),
                                  class: "ant-btn ant-btn-primary ss-tamanho-completo ss-dados-contratacao-btn",
                                  type: "button"
                                }, "Continuar")
                              ]),
                              _: 1
                            }, 8, ["spinning"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createElementVNode("button", {
                                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.redefinirSenha && _ctx.redefinirSenha(...args))),
                                class: "ant-btn ant-btn-primary ss-tamanho-completo ss-dados-contratacao-btn",
                                type: "button"
                              }, "Recuperar Senha"),
                              _hoisted_26
                            ], 64))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ((_ctx.state.passoAtivo === 4))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      (_ctx.state.aguardandoServidor)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_31))
                        : (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_35)),
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_a_skeleton, {
                          loading: _ctx.state.aguardandoServidor
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.planosAssinaturasTipoUso, (plano) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: plano.codigo,
                                class: "ss-dados-contratacao-plano"
                              }, [
                                _createElementVNode("h1", _hoisted_37, _toDisplayString(plano.nome), 1),
                                (plano.solicitarContato)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_41))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                      _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.obterPrecoPlano(1,plano.valores)), 1),
                                      _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.obterTextoRecorrenciaPlano(1,plano.valores)), 1)
                                    ])),
                                _createElementVNode("span", {
                                  class: "ss-dados-contratacao-descricao-plano",
                                  innerHTML: plano.descricao
                                }, null, 8, _hoisted_45),
                                _createElementVNode("ul", _hoisted_46, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plano.detalhes, (detalhePlano, index) => {
                                    return (_openBlock(), _createElementBlock("li", { key: index }, [
                                      _createVNode(_component_icone, { nome: "correto" }),
                                      _createTextVNode(_toDisplayString(detalhePlano.detalhe), 1)
                                    ]))
                                  }), 128))
                                ]),
                                (plano.solicitarContato)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      onClick: ($event: any) => (_ctx.solicitarContatoPlanoSelecionado(plano.codigo)),
                                      class: "ant-btn ss-tamanho-completo ss-dados-contratacao-plano-btn",
                                      type: "button"
                                    }, "Solicitar Contato", 8, _hoisted_47))
                                  : (_openBlock(), _createElementBlock("button", {
                                      key: 3,
                                      onClick: ($event: any) => (_ctx.definePlanoSelecionado(plano.codigo)),
                                      class: "ant-btn ss-tamanho-completo ss-dados-contratacao-plano-btn",
                                      type: "button"
                                    }, _toDisplayString(_ctx.obterTextoAcaoPlano(1,plano.valores)), 9, _hoisted_48))
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ((_ctx.state.passoAtivo === 5))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _createElementVNode("h2", null, _toDisplayString(_ctx.state.novaContratacao.nome) + ",", 1),
                      _hoisted_50,
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", _hoisted_53, [
                            _hoisted_54,
                            _createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              value: _ctx.state.tipoUso === _ctx.ETipoUso.Pessoal ? 'Controle Pessoal' : 'Controle Empresarial',
                              disabled: ""
                            }, null, 8, _hoisted_55)
                          ]),
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("label", null, _toDisplayString(_ctx.state.tipoUso === _ctx.ETipoUso.Pessoal ? 'CPF' : 'CNPJ'), 1),
                            (_ctx.state.tipoUso === _ctx.ETipoUso.Pessoal)
                              ? (_openBlock(), _createBlock(_component_campo_cpf, {
                                  key: 0,
                                  valor: _ctx.state.novaContratacao.cpfCnpj,
                                  "onUpdate:valor": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.novaContratacao.cpfCnpj) = $event)),
                                  disabled: true
                                }, null, 8, ["valor"]))
                              : (_openBlock(), _createBlock(_component_campo_cnpj, {
                                  key: 1,
                                  valor: _ctx.state.novaContratacao.cpfCnpj,
                                  "onUpdate:valor": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.novaContratacao.cpfCnpj) = $event)),
                                  disabled: true
                                }, null, 8, ["valor"]))
                          ]),
                          _createElementVNode("div", _hoisted_57, [
                            _hoisted_58,
                            _createElementVNode("span", _hoisted_59, [
                              _createElementVNode("span", _hoisted_60, [
                                _createVNode(_component_icone, {
                                  class: "ss-icone",
                                  nome: "email"
                                })
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.novaContratacao.email) = $event)),
                                disabled: ""
                              }, null, 512), [
                                [_vModelText, _ctx.state.novaContratacao.email]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_61, [
                            _hoisted_62,
                            _createVNode(_component_campo_telefone, {
                              valor: _ctx.state.novaContratacao.telefone,
                              "onUpdate:valor": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.novaContratacao.telefone) = $event)),
                              disabled: true
                            }, null, 8, ["valor"])
                          ])
                        ]),
                        _createVNode(_component_a_spin, {
                          spinning: _ctx.state.aguardandoServidor
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.concluirContratacao && _ctx.concluirContratacao(...args))),
                              class: "ant-btn ant-btn-primary ss-tamanho-completo ss-dados-contratacao-btn",
                              type: "button"
                            }, "Concluir Contratação")
                          ]),
                          _: 1
                        }, 8, ["spinning"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ((_ctx.state.passoAtivo === 6))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                      _createVNode(_component_a_result, {
                        status: "success",
                        title: "Contratação concluída com sucesso!",
                        "sub-title": "Aguarde em breve você receberá um e-mail de boas vindas com as suas informações de acesso."
                      })
                    ]))
                  : _createCommentVNode("", true),
                ((_ctx.state.passoAtivo === 7))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      _createVNode(_component_a_result, {
                        status: "success",
                        title: "Solicitação enviada com sucesso!",
                        "sub-title": "Aguarde em breve um de nossos consultores vão entrar em contato com você."
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
      ])
    ])
  ]))
}